import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingQuoteListItem } from './types';

export function useBillingQuotes(companyId?: number) {
  const { data, error, isLoading, mutate } = useSWR<TBillingQuoteListItem[]>(
    companyId === undefined
      ? 'commenda-billing/quotes'
      : `commenda-billing/quotes?companyId=${companyId}`,
    SWRFetcher({ method: 'GET' })
  );

  return { quotes: data ?? [], error, isLoading, mutate };
}
